import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslocoService } from "@jsverse/transloco";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { ASSET_CONSTANTS } from "../../../shared/constants/asset-constants";

@Component({
    selector:"app-mb-language-selector",
    templateUrl: "./mb-language-selector.component.html",
    imports: [
        FormsModule,
        NzIconModule,
        NzSelectModule,
        NzInputModule,
        NzFormModule,
    ]
})
export class MBLanguageSelectorComponent{
    currentLang = 'en';
    protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;

    constructor(private transloco: TranslocoService) {
        this.currentLang = this.transloco.getActiveLang();
    }

    onLanguageChange(lang: string): void {
        this.transloco.setActiveLang(lang);
        this.currentLang = lang;
        window.location.reload();
      }
}